import {
    CREATE_STYLE_DETAIL_FAILURE,
    CREATE_STYLE_DETAIL_REQUEST,
    CREATE_STYLE_DETAIL_SUCCESS,
    CREATE_USER_FORM_STYLE_DETAIL,
    DELETE_STYLE_DETAIL_FAILURE,
    DELETE_STYLE_DETAIL_REQUEST,
    DELETE_STYLE_DETAIL_SUCCESS,
    FETCH_STYLE_DETAIL_FAILURE,
    FETCH_STYLE_DETAIL_REQUEST,
    FETCH_STYLE_DETAIL_SUCCESS,
    FETCH_SINGLE_STYLE_DETAIL_FAILURE,
    FETCH_SINGLE_STYLE_DETAIL_REQUEST,
    FETCH_SINGLE_STYLE_DETAIL_SUCCESS,
    UPDATE_STYLE_DETAIL_FAILURE,
    UPDATE_STYLE_DETAIL_REQUEST,
    UPDATE_STYLE_DETAIL_SUCCESS,
    FETCH_STYLE_DETAIL_BY_ID_REQUEST,
    FETCH_STYLE_DETAIL_BY_ID_SUCCESS,
    FETCH_STYLE_DETAIL_BY_ID_FAILURE,
    STYLE_DETAIL_USERFORM_RESET,
    UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST,
    UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS,
    UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE,
    UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_REQUEST,
    UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_SUCCESS,
    UPDATE_STYLE_DETAIL_FROM_FABRIC_INFO_FAILURE,
    FETCH_STYLE_DETAIL_UPLOAD_IMAGES_REQUEST,
    FETCH_STYLE_DETAIL_UPLOAD_IMAGES_SUCCESS,
    FETCH_STYLE_DETAIL_UPLOAD_IMAGES_FAILURE,
    FETCH_STYLE_DETAIL_NEW_COLOR_ADD_REQUEST,
    FETCH_STYLE_DETAIL_NEW_COLOR_ADD_SUCCESS,
    FETCH_STYLE_DETAIL_NEW_COLOR_ADD_FAILURE
} from './styleDetail.actionsType';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchProductDetails, fetchProductDetailsWithIdData } from '../productDetails/productDetails.action';
import { fetchColorDetailsWithoutId } from '../colorDetails/colorDetails.actions';
import { updateSaleOrderAlterRegenerate } from '../stylePreparations/fabricInformation/fabricInformation.action';

// FETCH StyleDetail
export let fetchStyleDetail = () => {
    let config = {
        method: 'get',
        url: ConstantApi.styleDetailsGET,
        responseTypeRequest: FETCH_STYLE_DETAIL_REQUEST,
        responseTypeSuccess: FETCH_STYLE_DETAIL_SUCCESS,
        responseTypeFailure: FETCH_STYLE_DETAIL_FAILURE
    };
    return axiosCall(config);
};

export let fetchStyleDetailById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_STYLE_DETAIL_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_STYLE_DETAIL_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_STYLE_DETAIL_BY_ID_FAILURE
    };
    return axiosCall(config);
};

// CREATE StyleDetail
export let createStyleDetail = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldSubStyleNo: 'Auto Generated',
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSleeveType: parseInt(formData.fldFKSleeveType),
        fldFKNeckType: parseInt(formData.fldFKNeckType),
        fldFKTypeOfFit: parseInt(formData.fldFKTypeOfFit),
        fldFKProductType: parseInt(formData.fldFKProductType),
        fldFKYarn: parseInt(formData.fldFKYarn),
        fldFKFabricType: parseInt(formData.fldFKFabricType),
        fldProductType: 'string',
        fldGSM: 0,
        fldFKColour: 0,
        fldFKProcesses: parseInt(formData.fldFKProcesses),
        fldProcesses: formData.fldProcesses,
        fldColour: formData.fldColour.toString(),
        fldIsActive: true,
        fldEnteredSysId: formData.fldEnteredSysId,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString(),
        fldPreparedBy: 'string',
        fldPreparedOn: '2022-07-08T05:46:54.773Z',
        fldIsVerified: false,
        fldVerifiedBy: 'string',
        fldVerifiedOn: '2022-07-08T05:46:54.773Z',
        fldIsAuthorized: false,
        fldAuthorizedBy: 'string',
        fldAuthorizedOn: '2022-07-08T05:46:54.773Z',
        fldFKYarnMaterial: parseInt(formData.fldFKYarnMaterial),
        fldProcessingLossPercentage: Number(formData.fldProcessingLossPercentage) || 0,
        FldFKBaseColour: parseInt(formData.FldFKBaseColour) || 0
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.styleDetailsPOST}?FldId=${formData.fldFKColour}`,
        responseTypeRequest: CREATE_STYLE_DETAIL_REQUEST,
        responseTypeSuccess: CREATE_STYLE_DETAIL_SUCCESS,
        responseTypeFailure: CREATE_STYLE_DETAIL_FAILURE,
        resetFormData: STYLE_DETAIL_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchStyleDetailById(formData.fldFKStyle)
    };
    return axiosCall(config);
};

// GET SINGLE StyleDetails
export let getSingleStyleDetail = (id, productId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_STYLE_DETAIL_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_STYLE_DETAIL_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_STYLE_DETAIL_FAILURE,
        singlApiArray: [
            fetchCommonPropertyById(19), //Sleeve Type
            fetchCommonPropertyById(11), //Neck
            fetchCommonPropertyById(20), //Type Of Fit
            fetchCommonPropertyById(15), //Yarn
            fetchCommonPropertyById(17), //Fabric
            fetchCommonPropertyById(80), //Yarn material
            fetchColorDetailsWithoutId(),
            fetchProductDetailsWithIdData(productId),
            fetchProductDetails()
        ]
    };
    return axiosCall(config);
};

//UPDATE StyleDetails
export let updateStyleDetail = (formData) => {
    let today = new Date();
    let data = {
        fldId: parseInt(formData.fldId),
        fldSubStyleNo: formData.fldSubStyleNo,
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSleeveType: parseInt(formData.fldFKSleeveType),
        fldFKNeckType: parseInt(formData.fldFKNeckType),
        fldFKTypeOfFit: parseInt(formData.fldFKTypeOfFit),
        fldProductType: formData.fldProductType,
        // fldFKYarn: parseInt(formData.fldFKYarn),
        fldFKProductType: parseInt(formData.fldFKProductType),
        // fldFKFabricType: parseInt(formData.fldFKFabricType),
        fldProcessingLossPercentage: Number(formData.fldProcessingLossPercentage) || 0,
        fldFKProcesses: parseInt(formData.fldFKProcesses),
        fldProcesses: formData.fldProcesses,
        fldPCSWeightGMs: formData.fldPCSWeightGMs || 0,
        fldRequiredGSM: formData.fldRequiredGSM || 0,
        fldIsYPApproved: true,
        fldIsFPCompleted: true,
        fldIsFPApproved: true,
        fldIsPartPrePartCompleted: true,
        fldIsPartDetailDiaCompleted: true,
        fldIsPartDetailGrammageCompleted: true,
        fldIsPartDetailApproved: true,
        fldIsPCPKCompleted: true,
        fldISPCPKApproved: true,
        fldGSM: parseInt(formData.fldGSM),
        fldFKColour: parseInt(formData.fldFKColour),
        fldColour: formData.fldColour.toString(),
        fldIsActive: true,
        fldEnteredSysId: formData.fldEnteredSysId,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: formData.fldModifiedBy,
        fldModifiedDt: today.toISOString(),
        fldPreparedBy: 'string',
        fldPreparedOn: '2022-07-08T05:47:30.572Z',
        fldIsVerified: false,
        fldVerifiedBy: 'string',
        fldVerifiedOn: '2022-07-08T05:47:30.572Z',
        fldIsAuthorized: false,
        fldAuthorizedBy: 'string',
        fldAuthorizedOn: '2022-07-08T05:47:30.572Z',
        FldFKBaseColour: parseInt(formData.FldFKBaseColour) || 0,
        fldFKYarnMaterial: parseInt(formData.fldFKYarnMaterial)
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.styleDetailsPATCH}?FldId=${formData.fldId}`,
        responseTypeRequest: UPDATE_STYLE_DETAIL_REQUEST,
        responseTypeSuccess: UPDATE_STYLE_DETAIL_SUCCESS,
        responseTypeFailure: UPDATE_STYLE_DETAIL_FAILURE,
        resetFormData: STYLE_DETAIL_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchStyleDetailById(formData.fldFKStyle)
    };
    return axiosCall(config);
};

// DELETE StyleDetail
export let deleteStyleDetail = (id, styleMasterId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.styleDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_STYLE_DETAIL_REQUEST,
        responseTypeSuccess: DELETE_STYLE_DETAIL_SUCCESS,
        responseTypeFailure: DELETE_STYLE_DETAIL_FAILURE,
        modalClose: true,
        getAllData: fetchStyleDetailById(styleMasterId)
    };
    return axiosCall(config);
};

export let createStyleDetailUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_STYLE_DETAIL, payload: { key, value } });
    };
};

//UPDATE StyleDetails
export let updateStyleDetailFromStylePreparations = (formData, style) => {
    // let today = new Date();
    // let data = {
    //     ...formData,
    //     fldModifiedDt: today.toISOString()
    // };
    let config = {
        method: 'get',
        // data,
        url: `${ConstantApi.styleDetailsFabricInfoPATCH}&Style=${style}&RequiredGSM=${Number(
            formData[0].fldRequiredGSM
        )}&ProcessingLossPercentage=${Number(formData[0].fldProcessingLossPercentage)}&OAPercentage=${formData[0].fldOAPercentage}&PrintAccCost=${0 || formData[0].fldPrintAccessCost}`,
        responseTypeRequest: UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST,
        responseTypeSuccess: UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS,
        responseTypeFailure: UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        // payload: data,
        singlApiArray: [updateSaleOrderAlterRegenerate(style)]
    };
    return axiosCall(config);
};

export let updateStyleDetailFromStylePreparationsPcsWeight = (style) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleDetailsPcsWeightPATCH}?FldStylemaster=${style}`,
        responseTypeRequest: UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST,
        responseTypeSuccess: UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS,
        responseTypeFailure: UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [fetchStyleDetailById(style)]
    };
    return axiosCall(config);
};


export let styleDetailFromStylePreparationsFabricInfo = (style, ids) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.styleFabricInfo}?FldFkStyleId=${style}&FldStyleDetailId=${ids}`,
        responseTypeRequest: UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_REQUEST,
        responseTypeSuccess: UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_SUCCESS,
        responseTypeFailure: UPDATE_STYLE_DETAIL_FROM_FABRIC_INFO_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        // singlApiArray: [fetchStyleDetailById(style)]
    };
    return axiosCall(config);
};


export let fetchStyleDetailUploadImage = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.imageUploadPrevImageGet}/${id}`,
        responseTypeRequest: FETCH_STYLE_DETAIL_UPLOAD_IMAGES_REQUEST,
        responseTypeSuccess: FETCH_STYLE_DETAIL_UPLOAD_IMAGES_SUCCESS,
        responseTypeFailure: FETCH_STYLE_DETAIL_UPLOAD_IMAGES_FAILURE
    };
    return axiosCall(config);
};

export let fetchStyleNewColorAdd = (id, userData) => {
    let config = {
        method: 'post',
        url: `${ConstantApi.salesOrderNewColorAdd}?FldSaleOrder=${id}&FldCP=${userData || 0}`,
        responseTypeRequest: FETCH_STYLE_DETAIL_NEW_COLOR_ADD_REQUEST,
        responseTypeSuccess: FETCH_STYLE_DETAIL_NEW_COLOR_ADD_SUCCESS,
        responseTypeFailure: FETCH_STYLE_DETAIL_NEW_COLOR_ADD_FAILURE
    };
    return axiosCall(config);
};